"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextareaField = exports.TextareaComponent = void 0;
const core_1 = require("@material-ui/core");
const react_1 = __importDefault(require("react"));
const web_core_ui_textarea_1 = require("@opus/web.core.ui.textarea");
const web_core_form_text_field_1 = require("@opus/web.core.form.text-field");
const TextareaComponent = (_a) => {
    var { inputRef } = _a, props = __rest(_a, ["inputRef"]);
    return (react_1.default.createElement(core_1.Box, { mt: 1, width: "100%" },
        react_1.default.createElement(web_core_ui_textarea_1.Textarea, Object.assign({ ref: inputRef }, props))));
};
exports.TextareaComponent = TextareaComponent;
const TextareaField = (props) => {
    return react_1.default.createElement(web_core_form_text_field_1.TextField, Object.assign({ InputProps: { inputComponent: exports.TextareaComponent, disableUnderline: true }, InputLabelProps: { shrink: true } }, props));
};
exports.TextareaField = TextareaField;
//# sourceMappingURL=textarea-field.js.map